import { createUseStyles } from 'react-jss'
import { voucherValidationErrorStyles } from '../../../shared/voucher-common.styles'

export const useStyles = createUseStyles(voucherValidationErrorStyles)
